"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDIPutRequestSchema = exports.DDIPutRequest = void 0;
const DDIPutRequestSchema_1 = require("../../schemas/ddi/DDIPutRequestSchema");
Object.defineProperty(exports, "DDIPutRequestSchema", { enumerable: true, get: function () { return DDIPutRequestSchema_1.DDIPutRequestSchema; } });
class DDIPutRequest {
    constructor(values) {
        return Object.assign(this, values);
    }
    isValid() {
        return DDIPutRequestSchema_1.DDIPutRequestSchema.isValid(this);
    }
    validate() {
        return DDIPutRequestSchema_1.DDIPutRequestSchema.validate(this);
    }
}
exports.DDIPutRequest = DDIPutRequest;
